import { Component, ViewChild } from "@angular/core";
import { DevextremesharedmoduleModule } from "../../shared/Module/devextremeshared/devextremeshared.module";
import { UIUtils } from "../../services/uiutils.service";
import { AppStateManageService } from "../../services/app-state-manage.service";
import { ScreenSizeService } from "../../services/screensize.service";
import { Router } from "@angular/router";
import notify from "devextreme/ui/notify";
import { Utils } from "../../services/utils.service";
import { BFEmployeeRecord } from "../../classes/domain/entities/website/masters/bf/bf-employee-record/bfemployeerecord";
import { AshaPersonalInfoMaster } from "../../classes/domain/entities/website/masters/bf/personal-info-master/personalinfomaster";
import { DateconversionService } from "../../services/dateconversion.service";
import { Profile } from "../../classes/domain/entities/website/masters/login-user-profile/profile";
import { CancelbuttonComponent } from "../../shared/components/cancelbutton/cancelbutton.component";
import { ProfileUpdateCustomRequest } from "../../classes/domain/entities/website/masters/login-user-profile/saveprofilecustomrequest";
import { SessionValues } from "../../services/sessionvalues.service";
import { ServerCommunicatorService } from "../../services/server-communicator.service";
import { PayloadPacketFacade } from "../../classes/infrastructure/payloadpacket/payloadpacketfacade";
import { FileTransferObject } from "../../classes/infrastructure/filetransferobject";
import { DomainEnums } from "../../classes/infrastructure/enums";
import { BaseUrlService } from "../../services/baseurl.service";
import { SidebarMenuStateService } from "../../services/sidebarmenustateservice";
import { ProfileStateService } from "../../services/profilestate.service";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../services/language.service";
import { TextTranslationUtilService } from "../../services/text-translation.service";

@Component({
  selector: "app-bf-master",
  standalone: true,
  templateUrl: "profile.component.html",
  styleUrls: ["./profile.component.scss"],
  imports: [DevextremesharedmoduleModule, CancelbuttonComponent],
})
export class ProfileComponent {
  @ViewChild("fileInput") fileInput!: any;
  isSaveDisabled: boolean = false;
  IsNewEntity: boolean = true;
profileImageUrl: string | null = null;
  LoginUserProfileData: Profile[] = [];
  LoginUserRef: number = 0;
  LoginToken: string = "";
  singleImageFile: File | null = null;
  PrefixList = DomainEnums.HonorificsListLang(false);

  constructor(
    private uiUtils: UIUtils,
    private router: Router,
    private utils: Utils,
    private appStateManage: AppStateManageService,
    private baseUrl: BaseUrlService,
    private serverCommunicator: ServerCommunicatorService,
    private payloadPacketFacade: PayloadPacketFacade,
    private sidebarMenuState: SidebarMenuStateService,
    private profileState: ProfileStateService,
    public langService: LanguageService,
    private translate: TranslateService,
    private texttranslationUtil: TextTranslationUtilService,
  ) {}

  async ngOnInit() {
    this.LoginUserRef = this.appStateManage.getLoginUserRef();
    this.LoginToken = this.sidebarMenuState.getToken();
    if (this.LoginUserRef) {
      await this.FormulateUserRecord(this.LoginUserRef);
    }
  }

  isMarathi(): boolean {
    return this.langService.currentLang === "mr";
  }


  FormulateUserRecord = async (LoginUserRef: number) => {
    let lst = await Profile.FetchEntireListByLoginRef(
      LoginUserRef,
      async (errMsg) => await this.uiUtils.showErrorMessage("Error", errMsg),
    );
    this.LoginUserProfileData = lst;
    console.log('lst :', lst);
    // const cachedImage = this.appStateManage.getProfileImage();
    // if (cachedImage) {
    //   // ✅ Use saved base64 from sessionStorage
    //   this.profileImageUrl = cachedImage;
    // } else
       if (this.LoginUserProfileData[0].p.profile_pic_path) {
      const imageBaseUrl = this.baseUrl.GenerateImageBaseUrl();
      const serverUrl = `${imageBaseUrl}${this.LoginUserProfileData[0].p.profile_pic_path}/${this.LoginToken}?t=${Date.now() + 3000}`;
      this.profileImageUrl = serverUrl;
      this.appStateManage.setProfileImage(this.LoginUserProfileData[0].p.profile_pic_path);
    }
  };

  triggerImageUpload() {
    this.fileInput.nativeElement.click();
  }

  getTranslatedName = (item: any): string =>
    item ? this.translate.instant(item.Name) : "";

 onImageSelected(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Please select a valid image file");
      return;
    }

    // ✅ Revoke previous blob URL if any
    if (this.profileImageUrl && this.profileImageUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.profileImageUrl);
    }

    this.singleImageFile = file;
    this.profileImageUrl = URL.createObjectURL(file); // ✅ same as WorkGallery
  }

  restrictNonText(event: any): void {
    this.utils.restrictNonText(event);
  }

  FirstNameEnloading: boolean = false;
  FirstNameMrloading: boolean = false;

  MiddleNameEnloading: boolean = false;
  MiddleNameMrloading: boolean = false;

  LstNameEnloading: boolean = false;
  LstNameMrloading: boolean = false;

  async TranslateFirstNameToMarathi() {
  const value = this.LoginUserProfileData[0].p.first_name?.trim();
  if (!value) return;

  this.FirstNameMrloading = true;
  const translated = await this.texttranslationUtil.translate(value, "en-to-mr");
  if (translated !== null) {
    this.LoginUserProfileData[0].p.first_name_mr = translated;
  }
  this.FirstNameMrloading = false;
}

async TranslateMiddleNameToMarathi() {
  const value = this.LoginUserProfileData[0].p.middle_name?.trim();
  if (!value) return;

  this.MiddleNameMrloading = true;
  const translated = await this.texttranslationUtil.translate(value, "en-to-mr");
  if (translated !== null) {
    this.LoginUserProfileData[0].p.middle_name_mr = translated;
  }
  this.MiddleNameMrloading = false;
}

async TranslateLastNameToMarathi() {
  const value = this.LoginUserProfileData[0].p.last_name?.trim();
  if (!value) return;

  this.LstNameMrloading = true;
  const translated = await this.texttranslationUtil.translate(value, "en-to-mr");
  if (translated !== null) {
    this.LoginUserProfileData[0].p.last_name_mr = translated;
  }
  this.LstNameMrloading = false;
}

async TranslateFirstNameToEnglish() {
  const value = this.LoginUserProfileData[0].p.first_name_mr?.trim();
  if (!value) return;

  this.FirstNameEnloading = true;
  const translated = await this.texttranslationUtil.translate(value, "mr-to-en");
  if (translated !== null) {
    this.LoginUserProfileData[0].p.first_name = translated;
  }
  this.FirstNameEnloading = false;
}

async TranslateMiddleNameToEnglish() {
  const value = this.LoginUserProfileData[0].p.middle_name_mr?.trim();
  if (!value) return;

  this.MiddleNameEnloading = true;
  const translated = await this.texttranslationUtil.translate(value, "mr-to-en");
  if (translated !== null) {
    this.LoginUserProfileData[0].p.middle_name = translated;
  }
  this.MiddleNameEnloading = false;
}

async TranslateLastNameToEnglish() {
  const value = this.LoginUserProfileData[0].p.last_name_mr?.trim();
  if (!value) return;

  this.LstNameEnloading = true;
  const translated = await this.texttranslationUtil.translate(value, "mr-to-en");
  if (translated !== null) {
    this.LoginUserProfileData[0].p.last_name = translated;
  }
  this.LstNameEnloading = false;
}
  capitalizeFirstLetter(event: any, field: string): void {
    const input = event.event?.target as HTMLInputElement;
    if (!input) return;

    const value = input.value;
    if (!value) return;

    const capitalized = value.charAt(0).toUpperCase() + value.slice(1);

    if (value !== capitalized) {
      const cursorPos = input.selectionStart;
      input.value = capitalized;
      input.setSelectionRange(cursorPos, cursorPos);
      (this.LoginUserProfileData[0].p as any)[field] = capitalized;
    }
  }

  SaveProfile = async () => {
    const formData = new FormData();
    let req = new ProfileUpdateCustomRequest();
    for (let profileData of this.LoginUserProfileData) {
      req.id = profileData.p.id;
      req.personal_info_id = profileData.p.personal_info_id;
      req.first_name = profileData.p.first_name;
      req.middle_name = profileData.p.middle_name;
      req.last_name = profileData.p.last_name;
      req.first_name_mr = profileData.p.first_name_mr;
      req.middle_name_mr = profileData.p.middle_name_mr;
      req.last_name_mr = profileData.p.last_name_mr;
      req.email_id = profileData.p.email_id;
      req.mobile_no = profileData.p.mobile_no;
      req.profile_pic_path = this.singleImageFile?.name ?? this.LoginUserProfileData[0].p.profile_pic_path;
      req.honorific = profileData.p.honorific;
      req.source_table = profileData.p.source_table;
    }
    const FTOList: FileTransferObject[] = [];
    if (this.singleImageFile) {
      formData.append(
        "profile_pic_file",
        this.singleImageFile,
        this.singleImageFile.name,
      );
      
      const fileTransferObj = new FileTransferObject();
      fileTransferObj.id = "profile_pic_file";
      fileTransferObj.rawFile = this.singleImageFile;
      fileTransferObj.name = this.singleImageFile.name;
      
      FTOList.push(fileTransferObj);
    }
    
    let td = req.FormulateTransportData();
    let pkt = this.payloadPacketFacade.CreateNewPayloadPacket2(td);
    let tr = await this.serverCommunicator.sendHttpRequest(
      pkt,
      "acceptrequest",
      FTOList,
    );
    console.log('req :', req);
  if (!tr.Successful) {
      await this.uiUtils.showErrorMessage("Error", tr.Message);
      return;
    }

 if (this.singleImageFile) {
      const ext = this.singleImageFile.name.split('.').pop();
      const serverFileName = `profile_pic_file_${req.personal_info_id}.${ext}`;

      // ✅ Store filename in appStateManage
      this.appStateManage.setProfileImage(serverFileName);

      // ✅ Send filename to profileState so header builds correct server URL
      this.profileState.setProfileImage(serverFileName);  // ← NOT blob URL

      // ✅ Blob only for local preview on profile page
      if (this.profileImageUrl && this.profileImageUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.profileImageUrl);
      }
      this.profileImageUrl = URL.createObjectURL(this.singleImageFile);
    }

    //     // ✅ Wait 2 seconds for server to finish saving file
    // await new Promise(resolve => setTimeout(resolve, 8000));

    this.isSaveDisabled = false;
    this.singleImageFile = null;


    this.singleImageFile = null;
    notify("Profile saved successfully");

    const updatedName = `${req.first_name} ${req.middle_name} ${req.last_name}`.trim();
    this.profileState.setDisplayName(updatedName);
    // ✅ Wait for backend to finish writing file
// await new Promise(resolve => setTimeout(resolve, 3000));
// ✅ Re-fetch to get actual server filename after file is written
// await this.FormulateUserRecord(this.LoginUserRef);
    await this.backToDashboard();
    }


  backToDashboard = async () => {
    await this.router.navigate(["/home"]);
  };
}
